'use client';
import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import AllModelsSection from './components/AllModelsSection';
import AddOnsSection from './components/AddOnsSection';
import WhatsAppButton from '../homepage/components/WhatsAppButton';

export type CatalogCategory = 'customer' | 'distributor' | 'wholesale' | 'merchandise';

export default function ModelsPricingPage() {
  return (
    <>
      <Header />
      <main className="pt-20">
        <AllModelsSection />
        <AddOnsSection />
      </main>
      <Footer />
      <WhatsAppButton />
    </>
  );
}